import { getCurrentInstance } from 'vue';
import { BvToastOptions } from 'bootstrap-vue';

export type ToastVariant = 'primary' | 'error';

interface ToastOptions extends BvToastOptions {
  variant?: ToastVariant;
}

/**
 * Composable for displaying toast notifications
 * @returns Toast utility functions
 */
export function useToast() {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error('useToast must be called within setup()');
  }

  const toast = instance.proxy.$bvToast;

  const show = (message: string, options: ToastOptions = {}): void => {
    toast.toast(message, {
      title: options.title ?? '',
      variant: options.variant ?? 'primary',
      autoHideDelay: options.autoHideDelay ?? 3000,
      solid: true,
      ...options,
    });
  };

  const showSuccess = (message: string, title = ''): void => {
    show(message, { title, variant: 'primary' });
  };

  const showError = (message: string, title = ''): void => {
    show(message, { title, variant: 'error' });
  };

  return {
    show,
    showSuccess,
    showError,
  };
}
